import { cn } from "@/utils/cn"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-overlay-1 animate-pulse rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }
